export const CLASS_NAME = 'typography';
